// extracted by mini-css-extract-plugin
module.exports = {"container":"FallbackUi_container__2HY6i","content":"FallbackUi_content__1iZ9-","title":"FallbackUi_title__rIpyp","message":"FallbackUi_message__2bf0C"};